import { Box, Button, Link, Typography } from '@mui/material';
import React from 'react';

interface Props {
  children?: React.ReactElement<unknown>;
  href: string
  text: string
  subText: string
  color?: 'light' | 'dark'
  isActive?: boolean
  activeDisabled?: boolean
  width?: string
  margin?: string
  textAlign?: string
  onMouseEnter?: any
  onMouseLeave?: any
}

export default function NavButton(props: Props) {
  return (
    <Link
      href={props.href}
      sx={{
        margin: props.margin || 0,
        width: props.width || 'auto',
      }}
      onMouseEnter={() => { props.onMouseEnter && props.onMouseEnter() }}
    >
      <Button
        sx={(theme) => ({
          width: props.width || 'auto',
          justifyContent: 'flex-start',
          color: props.color === 'dark' ? theme.palette.grey[50] : theme.palette.grey[900],
          '&.active': {
            '.primary': {
              color: theme.palette.primary.main,
            },
            '.secondary': {
              color: theme.palette.secondary.main,
            },
            '&::after': {
              transform: 'scale(1, 1)'
            }
          },
          '&:after': {
            position: 'absolute',
            left: 0,
            content: `''`,
            width: '100%',
            height: 5,
            background: props.color === 'dark' ? theme.palette.grey[50] : theme.palette.grey[900],
            bottom: -1,
            transform: 'scale(0, 1)',
            transformOrigin: 'left top',
            transition: 'transform 0.3s'
          },
          '&:hover': {
            '&::after': {
              transform: 'scale(1, 1)'
            }
          }
        })}
        className={props.isActive && !props.activeDisabled ? 'active' : ''}
        size='large'
      >
        <Box sx={{ minWidth: '75px', textAlign: props.textAlign || 'center' }}>
          <Typography fontSize={'1.1rem'} fontWeight={'bold'}>
            <Box component={'span'} className={"primary"}>
              {props.text?.slice(0, 1)}
            </Box>
            <Box component={'span'} className={"secondary"}>
              {props.text?.slice(1, 2)}
            </Box>
            <Box component={'span'}>
              {props.text?.slice(2)}
            </Box>
          </Typography>
          <Typography fontSize={'0.9rem'}>
            {props.subText}
          </Typography>
        </Box>
      </Button>
    </Link>
  )
}